document.addEventListener("DOMContentLoaded", function () {
  const errorMessage = "The minimum order quantity is 10.";
  const form = document.querySelector('form[action="/cart"]');

  if (form) {
    form.addEventListener("submit", function (event) {
      let totalQuantity = 0;

      document.querySelectorAll('[name="updates[]"]').forEach(input => {
        totalQuantity += parseInt(input.value, 10) || 0;
      });

      if (totalQuantity < 10) {
        event.preventDefault();
        alert(errorMessage);
      }
    });
  }
});
